import React from 'react'
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import Description from "../../../../Components/Form/Description/Description";
import Button from "../../../../Components/Form/Button/Button";
import { formContent } from "./content"
import { useForm, FormProvider} from "react-hook-form";
import IdentityApi from "../../../../Api/IdentityApi";
// import { useHistory } from "react-router-dom";
import {getResponseError} from "../../../../Api/Utils/apiUtils";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import SuccessAlert from "../../../../Components/Form/SuccessAlert/SuccessAlert";

const {
    heading,
    description,
    email,
    recoverPasswordButton
} = formContent;

const ForgotPasswordComponent = () => {
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [successMessage, setSuccessMessage] = React.useState(null);
    const formBinding = useForm();
    const { watch, handleSubmit } = formBinding;
    // const history = useHistory(); 
    watch(() => setErrorMessage(''));

    const submitForm = async (data) => {
        const response = await IdentityApi.resetPassword(data.email);
        const apiError = getResponseError(response);
        if(apiError) {
            setSuccessMessage('');
            setErrorMessage(apiError);
        }else {
            setErrorMessage('');
            setSuccessMessage("Please check your email for password recovery link")
        }
    }
    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <SuccessAlert>{successMessage}</SuccessAlert>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <Description>{description}</Description>
                <FormProvider {...formBinding}>
                    <form id="forgot-password-form" onSubmit={handleSubmit(submitForm)}>
                        <TextInput {...email} />
                        <Button {...recoverPasswordButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default ForgotPasswordComponent
